import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import API from '../api';
import { loginSuccess, setLoading } from '../redux/authSlice';
import '../styles/Auth.css';

export default function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const theme = useSelector((state) => state.theme);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        dispatch(setLoading(true));
        try {
            const res = await API.post('/auth/login', { username, password });
            dispatch(loginSuccess(res.data));
            navigate('/');
        } catch (err) {
            setError(err.response?.data?.msg || 'An error occurred');
        } finally {
            dispatch(setLoading(false));
        }
    };

    return (
        <div className={`auth-container ${theme}`}>
            <form className="auth-form" onSubmit={handleSubmit}>
                <h2>Login</h2>
                {error && <p className="error-msg">{error}</p>}
                <div>
                    <label>Username</label>
                    <input
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>Password</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <button type="submit">Login</button>
                <p>
                    Don't have an account? <Link to="/register">Register</Link>
                </p>
            </form>
        </div>
    );
}
